// Function index:
//   mountPalette(parent, onPick) — render the terrain palette as clickable
//       swatches. Returns nothing; calls `onPick(terrainKey)` whenever the user
//       selects a new active terrain.

import { TERRAINS } from './types.js';

export function mountPalette(parent: HTMLElement, onPick: (terrainKey: string) => void): void {
  let activeTerrain = 'grass';
  for (const t of TERRAINS) {
    const sw = document.createElement('div');
    sw.className = 'terrain-swatch';
    sw.style.background = '#' + t.color.toString(16).padStart(6, '0');
    sw.dataset.terrain = t.key;
    sw.innerHTML = `<span class="label">${t.key}</span>`;
    sw.addEventListener('click', () => {
      activeTerrain = t.key;
      parent.querySelectorAll('.terrain-swatch').forEach((el) => el.classList.remove('active'));
      sw.classList.add('active');
      onPick(activeTerrain);
    });
    if (t.key === activeTerrain) sw.classList.add('active');
    parent.appendChild(sw);
  }
}
